import { render } from "./Resumen.vue?vue&type=template&id=6372786e&scoped=true"
import script from "./Resumen.vue?vue&type=script&lang=js"
export * from "./Resumen.vue?vue&type=script&lang=js"

import "./Resumen.vue?vue&type=style&index=0&id=6372786e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\daniel.montano\\Desktop\\montalvo.ti\\dish-frontend-web-site\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6372786e"]])

export default __exports__